/**
 * Именованные константы ставок НДС для строительных работ в Польше.
 * Заменяют магические числа (0.08, 0.23), делая ставки видимыми для ревью.
 *
 * Файл не имеет внутренних импортов — он является листовым узлом графа зависимостей.
 * Все потребители импортируют ИЗ этого файла; ничто сюда не импортируется.
 */

/**
 * Ставка НДС для жилищного строительства (budownictwo mieszkaniowe).
 * Применяется к: ремонту частных домов и квартир (Art. 41 ust. 12 ustawy o VAT z dnia 11.03.2004).
 * Льготная ставка действует только при условии, что объект признан «жилым» по PKOB.
 * КРИТИЧЕСКИ ВАЖНО: изменение этого значения меняет сумму НДС во всех жилых сметах.
 */
export const VAT_RATE_RESIDENTIAL = 0.08;

/**
 * Ставка НДС для коммерческого строительства (budownictwo komercyjne).
 * Применяется к: офисам, торговым помещениям, коммерческому ремонту.
 * Стандартная польская ставка НДС (stawka podstawowa) по Art. 41 ust. 1 ustawy o VAT.
 * КРИТИЧЕСКИ ВАЖНО: изменение этого значения меняет сумму НДС во всех коммерческих сметах.
 */
export const VAT_RATE_COMMERCIAL = 0.23;

/**
 * Ставка НДС по умолчанию для обратной совместимости.
 * Существующие сметы без явно указанной ставки получают коммерческую ставку 23%.
 * Это консервативный выбор: лучше завысить НДС, чем нарушить налоговое законодательство.
 */
export const VAT_RATE_DEFAULT = VAT_RATE_COMMERCIAL;

/**
 * Допустимые ставки НДС для строительных работ в Польше.
 * Только эти две ставки предусмотрены польским налоговым законодательством для строительства.
 * Используется для валидации входных данных в Zod-схемах (z.enum-подобная проверка).
 */
export const ALLOWED_VAT_RATES = [VAT_RATE_RESIDENTIAL, VAT_RATE_COMMERCIAL] as const;

/**
 * Тип допустимой ставки НДС, выведенный из кортежа ALLOWED_VAT_RATES.
 * Гарантирует, что только 0.08 или 0.23 могут быть использованы как VATRate.
 */
export type VATRate = (typeof ALLOWED_VAT_RATES)[number];
